import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { LanguageSwitcherComponent } from './language-switcher.component';
import { LanguageSwitcherPopoverComponent } from './language-switcher-popover/language-switcher-popover.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    LanguageSwitcherComponent,
    LanguageSwitcherPopoverComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule
  ],
  exports: [LanguageSwitcherComponent]
})
export class LanguageSwitcherModule { } 